var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5 7H1M1 7L7 1M1 7L7 13","stroke":"#A7A7A7"}));
}

BackArrow.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
